/**
 * Whether HSA/FSA surfaces should render for the shopper's country.
 *
 * HSA/FSA is a US tax instrument, so the storefront surfaces hide outside the
 * US. Shared by the PDP badge and the cart widget so the gate cannot diverge
 * between them.
 *
 * An absent country falls through to shown: `Shopify.country` is unset on some
 * themes and markets, and hiding on absence would silently suppress the
 * surfaces for US shoppers.
 */
export function isUnitedStates(): boolean {
  const country = globalThis.Shopify?.country;
  return !country || country === "US";
}
